import {
  ApolloClient,
  ApolloProvider,
  NormalizedCacheObject,
} from '@apollo/client';
import { FormatIcu } from '@tolgee/format-icu';
import { Tolgee, TolgeeProvider } from '@tolgee/react';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './assets/sass/_reset.scss';
import ApplicationBranding from './components/ApplicationBranding';
import LayoutComponent from './components/common/layout-component/LayoutComponent';
import LoggedInContainer from './components/LoggedInContainer';
import { GlobalContext } from './global-context/GlobalContext';
import AbandonedBusiness from './pages/abandoned-business/AbandonedBusiness';

interface IAppProps {
  apolloClient: ApolloClient<NormalizedCacheObject>;
}
export const tolgee = Tolgee()
  .use(FormatIcu())
  .init({
    defaultLanguage: 'fr',
    fallbackLanguage: 'fr',
    staticData: {
      en: () => import('./localization/i18n/en.json').then(m => m.default),
      fr: () => import('./localization/i18n/fr.json').then(m => m.default),
      de: () => import('./localization/i18n/de.json').then(m => m.default),
    },
  });
const App = ({ apolloClient }: IAppProps) => {
  return (
    <TolgeeProvider tolgee={tolgee} options={{ useSuspense: false }}>
      <ApplicationBranding>
        <Suspense fallback={<h1>Loading</h1>}>
          <ApolloProvider client={apolloClient}>
            <GlobalContext>
              <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <Routes>
                  <Route
                    path='/abandoned-business/:token'
                    element={<AbandonedBusiness />}
                  />
                  <Route
                    path='*'
                    element={
                      <LoggedInContainer>
                        <LayoutComponent />
                      </LoggedInContainer>
                    }
                  />
                </Routes>
              </BrowserRouter>
            </GlobalContext>
          </ApolloProvider>
        </Suspense>
      </ApplicationBranding>
    </TolgeeProvider>
  );
};
export default App;
